module.exports = __webpack_public_path__ + "static/media/微信.bd26a789.svg";